import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import t from "../../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import { Transition as i } from "../../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { defineComponent as e, h as r } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const f = e({
  name: "BaseIconSwitchTransition",
  setup(a, {
    slots: n
  }) {
    const o = t();
    return () => r(i, {
      name: "icon-switch-transition",
      appear: o.value
    }, n);
  }
});
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/icon-switch-transition/src/IconSwitchTransition.js
// module id = 139
// module chunks = 41